common.View.create('canvas.blocks.custom.cards.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        let owlCarousel = this.element.find('.owl-carousel');

        if (!owlCarousel.hasClass('disable-slider')) {
            owlCarousel.owlCarousel({
                items: 1,
                //loop: owlCarousel.find('> *').length > 1,
                loop: false,
                //autoplay: owlCarousel.data('autoplay'),
                nav: true,
                navContainer: this.element.find('.slider-arrows').get(0),
                autoplay: false,
                autoplayTimeout: 7500,
                autoplayHoverPause: true,
                autoplaySpeed: 1000,
                margin: 30,
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 2,
                    },
                    1024: {
                        items: 3,
                    },
                },
            });
        }
    }

});